import React, {Component} from 'react';
import AdminHomeTableRowCaseSlider from './admin-home-table-case-stuides-row';

class AdminHomeTableCaseSlider extends Component{

    

    render(){

        return(
           <div className="tab-pane fade " id="caseStudies" role="tabpanel">
                 <div className="text-center">
                    <a className="admin-add-btn red-btn" href="#addnewcasestudySliderModal" data-toggle="modal">اضافة سلايدر</a>
                </div>
               <div className="users-table-admin">
               
                <table className="table users-table-admin table-responsive-md">
                        <thead>
                            <tr>   
                                <th>اسم الشركة </th>
                                <th>وصف الشركة</th>
                                <th>الصورة</th>
                                <th>المهام</th>
                            </tr>
                        </thead>
                        <tbody>
                            <AdminHomeTableRowCaseSlider  companyName={"TNT شركة شحن"}   companyDescription={"شركة شحن عالمية تقوم بتوريد أي أشياء تريدها "} companyLogo={"Link"}/>
                            <AdminHomeTableRowCaseSlider  companyName={"TNT شركة شحن"}   companyDescription={"شركة شحن عالمية تقوم بتوريد أي أشياء تريدها "} companyLogo={"Link"}/>
                            <AdminHomeTableRowCaseSlider  companyName={"TNT شركة شحن"}   companyDescription={"شركة شحن عالمية تقوم بتوريد أي أشياء تريدها "} companyLogo={"Link"}/>
                            <AdminHomeTableRowCaseSlider  companyName={"TNT شركة شحن"}   companyDescription={"شركة شحن عالمية تقوم بتوريد أي أشياء تريدها "} companyLogo={"Link"}/>
                            <AdminHomeTableRowCaseSlider  companyName={"TNT شركة شحن"}   companyDescription={"شركة شحن عالمية تقوم بتوريد أي أشياء تريدها "} companyLogo={"Link"}/>
                        </tbody>
                    </table>
                </div>
            </div>
                        
            
        );
       
    }

};
export default AdminHomeTableCaseSlider;


